import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "10", y2: "16", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "9", x2: "15", y1: "13", y2: "13", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderPlus";
const FolderPlus = memo(themed(Icon));
export {
  FolderPlus
};
//# sourceMappingURL=folder-plus.js.map
